import reject from "lodash/reject";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import map from "lodash/map";
import find from "lodash/find";
import isEqual from "lodash/isEqual";
export default {
  namespaced: true,
  state: {
    activeEditOverlayId: null
  },
  getters: {
    activeOverlay(state, getters, rootState) {
      if (rootState.currentShowDetails && state.activeEditOverlayId) {
        var overlayArray = rootState.currentShowDetails.data.overlayArray || [];
        return find(overlayArray, { id: state.activeEditOverlayId });
      }
      return null;
    },
    overlays(state, getters, rootState) {
      if (rootState.currentShowDetails) {
        return rootState.currentShowDetails.data.overlayArray || [];
      }
      return [];
    }
  },
  mutations: {
    setActiveEditOverlayId(state, id) {
      console.log("setActiveEditOverlayId");
      state.activeEditOverlayId = id;
    }
  },
  actions: {
    updateOverlayInpoint({ rootState, dispatch }, overlayObject) {
      var overlay_id = overlayObject.id;
      var inpoint = overlayObject.inpoint;
      var overlayArray = rootState.currentShowDetails.data.overlayArray || [];
      var overlay = find(overlayArray, { id: overlay_id });
      if (overlay) {
        // Clone it and update.
        overlay = cloneDeep(overlay);
        if (overlay.inpoint != inpoint) {
          // Only update if different.
          overlay.inpoint = inpoint;
          dispatch("updateOverlay", overlay);
          console.log("updateOverlayInpoint", overlay_id, inpoint);
        }
      }
    },
    updateOverlayInpointAndDuration({ rootState, dispatch }, overlayObject) {
      var overlay_id = overlayObject.id;
      var inpoint = overlayObject.inpoint;
      var duration = overlayObject.duration; // This duration value includes the transition_seconds.
      var overlayArray = rootState.currentShowDetails.data.overlayArray || [];
      var overlay = find(overlayArray, { id: overlay_id });
      // Check for minimum duration (factoring in the transition_seconds)
      var minimumDuration = 0.1;
      if (duration - overlay.transition_seconds < minimumDuration) {
        duration = overlay.transition_seconds + 0.1;
      }
      if (overlay) {
        // Clone is and update.
        // Make sure to subtract the transition_seconds from this duration value.
        overlay = cloneDeep(overlay);
        overlay.inpoint = inpoint;
        overlay.duration = duration - overlay.transition_seconds;
        dispatch("updateOverlay", overlay);
        console.log(
          "updateOverlayInpointAndDuration",
          overlay_id,
          inpoint,
          duration
        );
      }
    },
    updateOverlay({ dispatch, rootState }, overlayObject) {
      var overlayArray = rootState.currentShowDetails.data.overlayArray || [];
      var overlays = cloneDeep(overlayArray);

      // Find a matching overlay if available.
      var overlay = find(overlayArray, { id: overlayObject.id });
      if (overlay) {
        // Found it, see if these match.
        if (isEqual(overlay, overlayObject)) {
          console.log("overlay is unchanged. No update needed.");
          return;
        }
      }

      // Is this a new one, check the ids.
      if (map(overlays, "id").includes(overlayObject.id)) {
        // Update the overlay in place.
        overlays = overlays.map(o => {
          if (o.id == overlayObject.id) {
            console.log("Updating " + o.id);
            return overlayObject;
          }
          return o;
        });
      } else {
        // Append the new overlay.
        overlays.push(overlayObject);
      }

      overlays = sortBy(overlays, "inpoint");

      //console.log(overlays);
      dispatch("updateOverlayArray", overlays);
    },
    removeOverlayById({ dispatch, rootState }, overlay_id) {
      var overlayArray = rootState.currentShowDetails.data.overlayArray || [];
      var overlays = cloneDeep(overlayArray);
      overlays = overlays.filter(o => {
        return o.id != overlay_id;
      });
      dispatch("updateOverlayArray", overlays);
    },
    updateActiveEditOverlayId({ commit }, id) {
      commit("setActiveEditOverlayId", id);
      if (id) {
        // If null, do not change status of property mode.
        commit("setPropertyMode", "item", { root: true });
      }
    },
    updateOverlayArray({ commit, dispatch }, overlay_array) {
      overlay_array = reject(overlay_array, { type: "trial_watermark" });
      commit("saveOverlayArrayToShow", overlay_array, { root: true });
      dispatch("updateCurrentShow", null, { root: true });
    }
  }
};
